import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../Button';
import DeleteAccountDialog from './DeleteAccountDialog';
import { useAuth } from '../../context/AuthContext';
import { useSyncStatus } from '../../context/SyncContext';
import { deletionMessage } from '../../domain/accountDeletion';
import s from './settings.module.css';

// Business Settings → Membership → Delete Account (#432).
//
// ── Where it lives ─────────────────────────────────────────────────────────
//
// Under the subscription, on the tab about the teacher's relationship with us
// rather than their studio's records; ours, as MMS's account closing is
// unrecorded. functions/billing/README.md ("Deleting an account deletes the
// studio") has what happens when the button is pressed.
//
// ── Why the whole screen reloads afterwards ─────────────────────────────────
//
// The Firestore client is terminated to clear its cache (src/data/
// accountDeletion.js), and a terminated client cannot be started again in the
// same page. So the done screen is reached by a document load, not a route
// change: the router lands on /account-deleted, then the page reloads there
// with a fresh client and nobody signed in.
const w = deletionMessage;

export default function DeleteAccountPanel() {
  const { deleteAccount, reauthMethod } = useAuth();
  const { isOnline, pendingCount } = useSyncStatus();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  return (
    <div className={s.panel}>
      <div className={s.panelTitle}>{w('title')}</div>
      <p className={s.blurb}>{w('lead')}</p>
      <p className={s.note}>{w('billing')} {w('keepRecords')}</p>
      <div className={s.actions}>
        <Button variant="danger" onClick={() => setOpen(true)}>{`${w('button')}…`}</Button>
      </div>
      <DeleteAccountDialog
        open={open}
        online={isOnline}
        owedWrites={pendingCount}
        reauth={reauthMethod}
        onDelete={deleteAccount}
        onCancel={() => setOpen(false)}
        onDeleted={() => {
          navigate('/account-deleted', { replace: true });
          window.location.reload();
        }}
      />
    </div>
  );
}
